import { render, staticRenderFns } from "./RetailCRM.vue?vue&type=template&id=79014844&"
import script from "./RetailCRM.vue?vue&type=script&lang=js&"
export * from "./RetailCRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports